var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { staticClass: "mt-1", attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "my-1",
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.createPO()
                      },
                    },
                  },
                  [_vm._v(" Create Purchase Order ")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "b-col",
            { staticClass: "my-1", attrs: { cols: "12", md: "2", sm: "2" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0" },
                [
                  _c(
                    "label",
                    { staticClass: "d-inline-block text-sm-left mr-50" },
                    [_vm._v("Per page")]
                  ),
                  _c("b-form-select", {
                    attrs: {
                      id: "perPageSelect",
                      size: "sm",
                      options: _vm.pageOptions,
                    },
                    model: {
                      value: _vm.perPage,
                      callback: function ($$v) {
                        _vm.perPage = $$v
                      },
                      expression: "perPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-end mb-2",
              staticStyle: { position: "relative", "z-index": "1" },
              attrs: { cols: "12" },
            },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-danger" },
                  on: { click: _vm.clearFilters },
                },
                [_vm._v(" Clear Filters ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              attrs: { cols: "12" },
              scopedSlots: _vm._u([
                {
                  key: "cell(checkbox)",
                  fn: function (data) {
                    return [
                      _c("b-form-checkbox", {
                        attrs: { value: data.item.itemId },
                        on: {
                          change: function ($event) {
                            return _vm.handleCheckboxChange(data.item.itemId)
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "b-table",
                {
                  attrs: {
                    striped: "",
                    hover: "",
                    responsive: "",
                    "per-page": _vm.perPage,
                    "current-page": _vm.currentPage,
                    items: _vm.filteredData,
                    fields: _vm.fields,
                    "sort-by": _vm.sortBy,
                    "sort-desc": _vm.sortDesc,
                    "sort-direction": _vm.sortDirection,
                    filter: _vm.filter,
                  },
                  on: {
                    "update:sortBy": function ($event) {
                      _vm.sortBy = $event
                    },
                    "update:sort-by": function ($event) {
                      _vm.sortBy = $event
                    },
                    "update:sortDesc": function ($event) {
                      _vm.sortDesc = $event
                    },
                    "update:sort-desc": function ($event) {
                      _vm.sortDesc = $event
                    },
                    filtered: _vm.onFiltered,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "head(itemName)",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Item Name")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Filter by Item Name",
                                  size: "sm",
                                },
                                on: { input: _vm.filterTable },
                                model: {
                                  value: _vm.filters.itemName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "itemName", $$v)
                                  },
                                  expression: "filters.itemName",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "head(type)",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Item Type")]),
                              _c("b-form-select", {
                                attrs: { options: _vm.typeOptions, size: "sm" },
                                on: { change: _vm.filterTable },
                                model: {
                                  value: _vm.filters.type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "type", $$v)
                                  },
                                  expression: "filters.type",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "head(supplierName)",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Preferred Supplier")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Filter by Supplier",
                                  size: "sm",
                                },
                                on: { input: _vm.filterTable },
                                model: {
                                  value: _vm.filters.supplierName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "supplierName", $$v)
                                  },
                                  expression: "filters.supplierName",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "head(categoryName)",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Category")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Filter by Category",
                                  size: "sm",
                                },
                                on: { input: _vm.filterTable },
                                model: {
                                  value: _vm.filters.categoryName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "categoryName", $$v)
                                  },
                                  expression: "filters.categoryName",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "head(subCategoryName)",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Sub Category")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Filter by Sub Category",
                                  size: "sm",
                                },
                                on: { input: _vm.filterTable },
                                model: {
                                  value: _vm.filters.subCategoryName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "subCategoryName",
                                      $$v
                                    )
                                  },
                                  expression: "filters.subCategoryName",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "head(lowStockValue)",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Low Stock")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Filter by Low Stock",
                                  size: "sm",
                                },
                                on: { input: _vm.filterTable },
                                model: {
                                  value: _vm.filters.lowStockValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "lowStockValue", $$v)
                                  },
                                  expression: "filters.lowStockValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "head(currentStock)",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Current Stock")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Filter by Current Stock",
                                  size: "sm",
                                },
                                on: { input: _vm.filterTable },
                                model: {
                                  value: _vm.filters.currentStock,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "currentStock", $$v)
                                  },
                                  expression: "filters.currentStock",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "cell(checkbox)",
                      fn: function (data) {
                        return [
                          _c("b-form-checkbox", {
                            attrs: { value: data.item.itemId },
                            on: {
                              change: function ($event) {
                                return _vm.handleCheckboxChange(
                                  data.item.itemId
                                )
                              },
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(itemName)",
                      fn: function (data) {
                        return [_vm._v(" " + _vm._s(data.item.itemName) + " ")]
                      },
                    },
                    {
                      key: "cell(type)",
                      fn: function (data) {
                        return [
                          data.item.type === 1
                            ? _c("b-badge", { attrs: { variant: "primary" } }, [
                                _vm._v(" Finished Product "),
                              ])
                            : _vm._e(),
                          data.item.type === 2
                            ? _c("b-badge", { attrs: { variant: "info" } }, [
                                _vm._v(" Semi Finished Product "),
                              ])
                            : _vm._e(),
                          data.item.type === 3
                            ? _c(
                                "b-badge",
                                { attrs: { variant: "secondary" } },
                                [_vm._v(" Raw Material ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [_vm._v(" <")]
              ),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center mb-1" },
                [
                  !_vm.filterResults
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "d-flex justify-content-center",
                          attrs: { variant: "warning", show: "" },
                        },
                        [
                          _c("h4", { staticClass: "alert-heading" }, [
                            _vm._v("No items found"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              !_vm.filteredData.length
                ? _c(
                    "b-alert",
                    {
                      staticClass: "d-flex justify-content-center",
                      attrs: { variant: "warning", show: "" },
                    },
                    [_vm._v("No items found")]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center mb-1" },
                [
                  _vm.loading
                    ? _c("b-spinner", {
                        staticStyle: { width: "3rem", height: "3rem" },
                        attrs: {
                          variant: "success",
                          label: "Spinning",
                          block: "",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-pagination", {
                staticClass: "my-0",
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.perPage,
                  align: "center",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
              _c("b-form-group", [
                _vm._v(
                  " Showing " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? _vm.perPage * (_vm.currentPage - 1) + 1
                        : 0
                    ) +
                    " to " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                        : 0
                    ) +
                    " of " +
                    _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                    " entries "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }